module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic--FR-967a95176101c24373376f660a47666c.jpg";